import React, { useEffect, useRef, useState } from "react";
import { Form, Select } from "antd";
import QrScanner from "qr-scanner";
import QrFrame from "../../../App/Assets/qr-frame.svg";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
// import ProgressModal from "../../../App/Utils/ProgressModal";
// import GeneralDetails from "../Components/GeneralDetails";
import { DataProvider } from "../../DataProvider";
// import PackageDetails from "../Components/PackageDetails";
// import DeliveryDetails from "../Components/DeliveryDetails";
// import OtherDetails from "../Components/OtherDetails";
// import moment from "moment";

const TrackPackage = (props) => {
  const dataProvider = new DataProvider();
  const scanner = useRef();
  const videoEl = useRef(null);
  const qrBoxEl = useRef(null);
  const [qrOn, setQrOn] = useState(true);
  const [mstQRCode, setMstQRCode] = useState([]);

  const fetchQRDropdownValues = () => {
    dataProvider
      .getDropdownValues("MstQRCode", "&is_used=true")
      .then((response) => {
        if (response.ok) {
          response.json().then((data) => {
            setMstQRCode(data.results);
          });
        } else {
          response.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch((exception) =>
        openNotification("error", "Error", "Error connecting server")
      );
  };
  useEffect(() => {
    fetchQRDropdownValues();
    if (videoEl?.current && !scanner.current) {
      scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
        preferredCamera: "environment",
        highlightScanRegion: true,
        highlightCodeOutline: true,
        overlay: qrBoxEl?.current || undefined,
      });
      scanner?.current
        ?.start()
        .then(() => setQrOn(true))
        .catch((err) => {
          if (err) setQrOn(false);
        });
    }
    return () => {
      if (!videoEl?.current) {
        scanner?.current?.stop();
      }
    };
  }, []);

  const onScanSuccess = (result) => {
        if (result && result['data']) {
            alert("QR Code scanned successfully! press 'Ok' to see details")
            window.location.href='ViewPackage/'+result['data']
    }
  };

  return (
    <>
      <div>
        <center>
          <Form.Item required name="qr_code_value" label="">
            <Select
              allowClear
              showSearch
              style={{ width: "42%" }}
              placeholder="Select QR Code Value"
              options={mstQRCode.map((val) => ({
                value: val.value,
                label: val.value,
              }))}
              onChange={(e) => {
                window.location.href = "ViewPackage/" + e;
              }}
            />
          </Form.Item>
        </center>
      </div>
      <div className="qr-reader">
        <video ref={videoEl}></video>
        <div ref={qrBoxEl} className="qr-box">
          <img
            src={QrFrame}
            alt="Qr Frame"
            width={256}
            height={256}
            className="qr-frame"
          />
        </div>
      </div>
    </>
  );
};

export default TrackPackage;
